module.exports = __webpack_public_path__ + "static/media/logoEmpresa.ef183b65.svg";